import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ColorComparisonPage() {
  return <div className="w-full bg-[#f8f8f8]" data-id="element-705">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-706">
        <Link to="/" className="flex items-center text-gray-600 hover:text-[#214ae9] transition-colors font-medium" data-id="element-707">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-708" />
          <span data-id="element-709">Go Back</span>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-16" data-id="element-710">
        <div className="text-center mb-12" data-id="element-711">
          <h1 className="text-4xl md:text-5xl font-bold text-[#111111] mb-4" data-id="element-712">
            Color Strategy Options
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-713">
            Explore different approaches to using your brand colors. Each option
            shows a unique hierarchy and emphasis.
          </p>
        </div>

        <div className="space-y-16" data-id="element-714">
          {/* Option 1: Blue Primary (Current) */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-715">
            <div className="bg-[#1a0647] px-8 py-4 border-b border-gray-700" data-id="element-716">
              <h2 className="text-xl font-bold text-white" data-id="element-717">
                Option 1: Blue Primary
              </h2>
              <p className="text-sm text-gray-300" data-id="element-718">
                Professional and trustworthy • Current implementation
              </p>
            </div>
            <div className="p-8" data-id="element-719">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-720">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-721">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-722">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-723">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-724">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-725">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-lg flex items-center space-x-2" data-id="element-726">
                      <span data-id="element-727">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-728" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-729">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-730">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-731">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-732">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-733" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-734">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-735">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-736">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-737">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-738" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-739">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-740">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 2: Purple Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-741">
            <div className="bg-[#b063ff] px-8 py-4 border-b border-purple-400" data-id="element-742">
              <h2 className="text-xl font-bold text-white" data-id="element-743">
                Option 2: Purple Primary
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-744">
                Modern and energetic • Bold personality
              </p>
            </div>
            <div className="p-8" data-id="element-745">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-746">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-747">
                  <div className="inline-block bg-[#00f4f8] bg-opacity-20 text-[#00f4f8] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#00f4f8] border-opacity-30" data-id="element-748">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-749">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-750">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-751">
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg flex items-center space-x-2" data-id="element-752">
                      <span data-id="element-753">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-754" />
                    </button>
                    <button className="border-2 border-[#214ae9] text-[#214ae9] px-6 py-3 rounded-lg font-bold hover:bg-[#214ae9] hover:text-white transition-all" data-id="element-755">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-756">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-757">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-758">
                      <ShieldIcon className="w-6 h-6 text-[#b063ff]" data-id="element-759" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-760">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-761">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-762">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-763">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-764" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-765">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-766">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 3: Cyan Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-767">
            <div className="bg-[#00f4f8] px-8 py-4 border-b border-cyan-300" data-id="element-768">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-769">
                Option 3: Cyan Primary
              </h2>
              <p className="text-sm text-[#111111] text-opacity-70" data-id="element-770">
                Fresh and innovative • High energy
              </p>
            </div>
            <div className="p-8" data-id="element-771">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-772">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-773">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-774">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-775">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-776">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-777">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-[#00d9dd] transition-all shadow-lg flex items-center space-x-2" data-id="element-778">
                      <span data-id="element-779">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-780" />
                    </button>
                    <button className="border-2 border-[#b063ff] text-[#b063ff] px-6 py-3 rounded-lg font-bold hover:bg-[#b063ff] hover:text-white transition-all" data-id="element-781">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-782">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-783">
                    <div className="w-12 h-12 bg-[#00f4f8] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-784">
                      <ShieldIcon className="w-6 h-6 text-[#00f4f8]" data-id="element-785" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-786">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-787">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-788">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-789">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-790" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-791">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-792">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 4: Balanced Trio */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-793">
            <div className="bg-gradient-to-r from-[#214ae9] via-[#b063ff] to-[#00f4f8] px-8 py-4" data-id="element-794">
              <h2 className="text-xl font-bold text-white" data-id="element-795">
                Option 4: Balanced Trio
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-796">
                Equal emphasis • Vibrant and dynamic
              </p>
            </div>
            <div className="p-8" data-id="element-797">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-798">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-799">
                  <div className="inline-block bg-white bg-opacity-10 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-white border-opacity-20" data-id="element-800">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-801">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-802">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-803">
                    <button className="bg-gradient-to-r from-[#214ae9] to-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:shadow-xl transition-all shadow-lg flex items-center space-x-2" data-id="element-804">
                      <span data-id="element-805">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-806" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-807">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-808">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-809">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-810">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-811" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-812">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-813">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-814">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-815">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-816" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-817">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-818">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 5: High Contrast */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-819">
            <div className="bg-[#111111] px-8 py-4 border-b border-gray-800" data-id="element-820">
              <h2 className="text-xl font-bold text-white" data-id="element-821">
                Option 5: High Contrast
              </h2>
              <p className="text-sm text-gray-400" data-id="element-822">
                Bold and striking • Maximum impact
              </p>
            </div>
            <div className="p-8" data-id="element-823">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-824">
                {/* Hero preview */}
                <div className="bg-[#111111] rounded-xl p-8 border-2 border-[#00f4f8]" data-id="element-825">
                  <div className="inline-block bg-[#00f4f8] text-[#111111] px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-826">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-827">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-828">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-829">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-white transition-all shadow-lg flex items-center space-x-2" data-id="element-830">
                      <span data-id="element-831">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-832" />
                    </button>
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg" data-id="element-833">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-834">
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-835">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-836">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-837" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-838">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-839">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-840">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-841">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-842" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-843">
                      Easy to Use
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-844">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6: Light & Airy */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-845">
            <div className="bg-white px-8 py-4 border-b-2 border-[#214ae9]" data-id="element-846">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-847">
                Option 6: Light & Airy
              </h2>
              <p className="text-sm text-gray-600" data-id="element-848">
                Minimal and clean • Approachable
              </p>
            </div>
            <div className="p-8" data-id="element-849">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-850">
                {/* Hero preview */}
                <div className="bg-white rounded-xl p-8 border-2 border-gray-200" data-id="element-851">
                  <div className="inline-block bg-[#214ae9] bg-opacity-5 text-[#214ae9] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#214ae9] border-opacity-20" data-id="element-852">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-[#111111] mb-4" data-id="element-853">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-854">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-855">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-md flex items-center space-x-2" data-id="element-856">
                      <span data-id="element-857">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-858" />
                    </button>
                    <button className="bg-white border-2 border-gray-300 text-[#111111] px-6 py-3 rounded-lg font-bold hover:border-[#214ae9] hover:text-[#214ae9] transition-all" data-id="element-859">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-860">
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#214ae9] transition-colors" data-id="element-861">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-862">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-863" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-864">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-865">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#b063ff] transition-colors" data-id="element-866">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-867">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-868" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-869">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-870">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}